'use strict';

/* globals urls */

var $ = require('jquery');

$('.favourite-button').click(function(e) {
	e.preventDefault();
	var postID = parseInt($(this).data('post-id'), 10);
	var nonce = $(this).data('nonce');


	if ($(this).hasClass('favourited')) {
		var text = $(this).data('text-not-favourite');
	}
	else {
		var text = $(this).data('text-favourite');
	}

	$(this).find('.favourite-text').text(text);
	$(this).toggleClass('favourited');
	
	// TODO :: Favourites
	$.ajax({
		type: 'POST',
		url: urls.adminAjax,
		data: {
			'post_id': postID,
			'_wpnonce': nonce,
			'action': 'favourite_benefit',
		},
		dataType: 'json',
		xhrFields: {
			withCredentials: true,
		},
		complete: function(a, b){
			// console.log(a);
			// console.log(b);
		}
	})
	.then(function() {
		// Do stuff
	});
});
